<style>
.example-h2 {
  margin: 10px;
}

.example-section {
  display: flex;
  align-content: center;
  align-items: center;
  height: 60px;
}

.example-margin {
  margin: 0 10px;
}
</style>
<h2 mat-dialog-title>Create an Exercise</h2>

<mat-dialog-content class="mat-typography">
 
  

    <table>
      <tr style="height: 40px;">
        <td>
            <label class="example-margin">Exam:</label>
        </td>
        <td>
            <mat-checkbox class="example-margin" >CE</mat-checkbox>
            <mat-checkbox class="example-margin" >DSE</mat-checkbox>
        </td>
      </tr>
      <tr style="height: 40px;">
          <td>
              <label class="example-margin">No. of questions:</label>
          </td>
          <td>
              <mat-select placeholder="Select a number">
                  <mat-option value="10">10</mat-option>
                  <mat-option value="15">15</mat-option>
                  <mat-option value="20">20</mat-option>
                  <mat-option value="25">25</mat-option>
                  <mat-option value="30">30</mat-option>
                  <mat-option value="35">35</mat-option>
                  <mat-option value="40">40</mat-option>
                  <mat-option value="45">45</mat-option>
                  <mat-option value="50">50</mat-option>
                </mat-select>
          </td>
      </tr>
      <tr style="height: 40px;">
        <td>
            <label class="example-margin">Topic:</label>
        </td>
        <td>
            <mat-select placeholder="Select Topic"  multiple>
                <mat-option *ngFor="let topic of data.topics" value="{{topic.tag}}">{{topic.name}}</mat-option>
                
            </mat-select>
        </td>
      </tr>
    </table>



</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Create and Start!</button>
</mat-dialog-actions>